var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { commonCssStyles } from "../../global-styles.js";
let NavMenuTextButton = class NavMenuTextButton extends LitElement {
    focus(options) {
        this.shadowRoot.getElementById("nav-link").focus(options);
    }
    render() {
        return html `
      <button
        id="nav-link"
        class="container"
        role="menuitem"
        aria-labelledby="label-text"
      >
        <div class="text-container">
          <div id="label-text" class="label">${this.text}</div>
          <div class="rule"></div>
        </div>
      </button>
    `;
    }
};
// noinspection CssUnresolvedCustomProperty,CssNoGenericFontName
NavMenuTextButton.styles = [
    commonCssStyles,
    css `
      .container {
        background-color: transparent;
        margin: 0;
        padding: 0;
        text-align: inherit;
        font: inherit;
        width: 100%;
        display: flex;
        text-decoration: none;
        border: 2px solid transparent;
        border-radius: 4px;
      }

      .container .text-container {
        display: flex;
        height: 31px;
        flex-direction: column;
        align-items: flex-start;
      }

      .container .text-container .label {
        display: flex;
        align-items: center;
        flex: 1 0 0;
        color: var(--text-text-color);
        font-family: var(--text-font-family);
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
      }

      .container .text-container .rule {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        align-self: stretch;
        height: 1px;
        min-height: 1px;
        background: var(--tones-lavender50-color);
        width: 0;
      }

      .container .text-container * {
        transition: var(--delay-transition75);
      }

      .container:hover {
        cursor: pointer;
      }

      .container:hover .text-container .label {
        color: var(--tones-lavender50-color);
      }

      .container:hover .text-container .rule {
        width: 100%;
      }

      .container:focus-visible {
        outline: none;
        border: 2px solid var(--tones-lavender50-color);
      }
    `,
];
__decorate([
    property()
], NavMenuTextButton.prototype, "text", void 0);
NavMenuTextButton = __decorate([
    customElement("nav-menu-text-button")
], NavMenuTextButton);
export { NavMenuTextButton };
